/* eslint-disable class-methods-use-this */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// native components
import AnswersTo1099IntFaq from './components/answersTo1099IntFaq';
import AnswersTo1099RFaq from './components/answersTo1099RFaq ';
import AnswersTo1099Faq from './components/answersTo1099Faq';
import AnswersToCommonBillingQuestionsFaq from './components/answersToCommonBillingQuestionsFaq';
import ApplyEarlyPaymentBenefitSection from './components/applyEarlyPaymentBenefitSection';
import ApplyPolicyLoanSection from './components/applyPolicyLoanSection';
import ChangeTheBeneficiarySection from './components/changeTheBeneficiarySection';
import ChangeTheOwnerOfPolicySection from './components/changeTheOwnerOfPolicySection';
import ConvertTermInsuranceToPermanentInsuranceSection from './components/convertTermInsuranceToPermanentInsuranceSection';
import LearnAboutFixedSettlementPlansSection from './components/learnAboutFixedSettlementPlansSection';
import LearnAboutModifiedEndowmentsFaq from './components/learnAboutModifiedEndowmentsFaq';
import LearnAboutSettlementNoticesSection from './components/learnAboutSettlementNoticesSection';
import LearnAboutVariableSettlementPlanSection from './components/learnAboutVariableSettlementPlanSection';
import OnlineInfoSection from './components/onlineInfoSection';
import PremiumPaymentSection from './components/premiumPaymentSection';
import ReceiveOneBillForMultiplePoliciesSection from './components/receiveOneBillForMultiplePoliciesSection';
import RequestTechnicalFaq from './components/requestTechnicalFaq';
import SettlementPlansSection from './components/settlementPlansSection';
import SubmitWaiverPremiumClaimSection from './components/submitWaiverPremiumClaimSection';
import SurrenderAPolicySection from './components/surrenderAPolicySection/surrenderAPolicySection';
import SubmitADeathClaimSection from './components/submitADeathClaimSection';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Frequently Asked Questions',
          linkUrl: '/faq/',
          linkAriaLabel: 'Northwestern Mutual Frequently Asked Questions',
        },
        {
          pageName: 'Life Insurance - Frequently Asked Questions',
          linkUrl: '/faq/life-insurance-faq/',
          linkAriaLabel: 'Northwestern Mutual Life Insurance - Frequently Asked Questions',
        },
      ]}
      mainAttributes={{
        itemScope: true,
        itemType: 'https://schema.org/FAQPage',
      }}>

      {/* ONLINE INFO SECTION */}
      <OnlineInfoSection />

      {/* ANSWERS TO COMMON 1099-INT QUESTIONS FAQ */}
      <AnswersTo1099Faq />

      {/* ANSWERS TO COMMON 1099 QUESTIONS FAQ */}
      <AnswersTo1099IntFaq />

      {/* ANSWERS TO COMMON 1099R QUESTIONS FAQ */}
      <AnswersTo1099RFaq />

      {/* ANSWERS TO COMMON BILLING QUESTIONS FAQ */}
      <AnswersToCommonBillingQuestionsFaq />

      {/* APPLY POLICY LOAN SECTION */}
      <ApplyPolicyLoanSection />

      {/* APPLY EARLY PAYMENT BENEFIT SECTION */}
      <ApplyEarlyPaymentBenefitSection />

      {/* APPLY POLICY LOAN SECTION */}
      <ChangeTheBeneficiarySection />

      {/* APPLY POLICY LOAN SECTION */}
      <ChangeTheOwnerOfPolicySection />

      {/* SETTLEMENT PLANS SECTION */}
      <SettlementPlansSection />

      {/* CONVERT TERM INSURANCE TO PERMANENT INSURANCE SECTION */}
      <ConvertTermInsuranceToPermanentInsuranceSection />

      {/* LEARN ABOUT FIXED SETTLEMENT PLANS SECTION */}
      <LearnAboutFixedSettlementPlansSection />

      {/* LEARN ABOUT MODIFIED ENDOWMENTS (MEC's) FAQ */}
      <LearnAboutModifiedEndowmentsFaq />

      {/* LEARN ABOUT SETTLEMENT NOTICE SECTION */}
      <LearnAboutSettlementNoticesSection />

      {/* LEARN ABOUT VARIABLE SETTLEMENT PLAN SECTION */}
      <LearnAboutVariableSettlementPlanSection />

      {/* PREMIUM PAYMENT SECTION */}
      <PremiumPaymentSection />

      {/* RECIEVE ONE BILL FOR MULTIPLE POLICIES SECTION */}
      <ReceiveOneBillForMultiplePoliciesSection />

      {/* REQUEST TECHNICAL HELP FAQ */}
      <RequestTechnicalFaq />

      {/* SUBMIT A DEATH CLAIM SECTION */}
      <SubmitADeathClaimSection />

      {/* SUBMIT WAIVER OF PREMIUM CLAIM SECTION */}
      <SubmitWaiverPremiumClaimSection />

      {/* SURRENDER A POLICY SECTION */}
      <SurrenderAPolicySection />
    </Page>

  );
};
